(ns practitest.frontend.components.grid.common
  (:require [clojure.string :as str]))

(defn header-title [column]
  (str (or (:header column)
           (:field column))))

(defonce types-registry (atom {}))

;; Registers new cell type with required functions
;; cell-fn   -> (fn [column-info row tableprops]) -> reagent view for cell
;; text-fn   -> (fn [column-info row]) -> text (for sorting/filtering)
;; header-fn -> (fn [column-info])     -> reagent view for header

;; TODO: replace text-fn with those 2 functions (e.g. for display ID sorting)
;; search-fn -> (fn [column-info cell filter-state]) -> true / false
;; sort-fn   -> (fn [column-info cell-a cell-b]) -> -1 / 0 / 1
(defn register-field-type!
  [type
   header-fn
   text-fn
   cell-fn]
  (swap! types-registry
         assoc type
         {:text-fn text-fn
          :header-fn header-fn
          :cell-fn cell-fn}))

(defn- default-handler
  [{:keys [type] :as column-info} & _]
  (str "Column type " type " is not supported"))

(defn- get-cell-definition
  [type]
  (or (get @types-registry type)
      {:text-fn default-handler
       :header-fn default-handler
       :cell-fn default-handler}))

(defn header-cell
  [column-info]
  ((:header-fn (get-cell-definition (:type column-info)))
   column-info))

(defn cell-text
  [column-info row]
  ((:text-fn (get-cell-definition (:type column-info)))
   column-info row))

(defn body-cell
  [column-info row props]
  ((:cell-fn (get-cell-definition (:type column-info)))
   column-info row props))

(defn parse-multiple-options [s]
  ;in entity index view - grid filter ID - s will be a string like "1,2,3"
  ;in add test instances - grid filter ID - s will be a map like {:from 37, :to 73}
  (when s
    (if (map? s)
      s
      (mapv str/trim (str/split s #",")))))
